import {Head, usePage} from '@inertiajs/react'
import Layout from "../../components/layout";
import InstallPWA from '../../components/installPWA.jsx';
import React, {useEffect} from 'react';
import toast from 'react-hot-toast';
import {useTranslation} from 'react-i18next';
import {Blurhash} from 'react-blurhash';

export default function Join({eventName, coverUrl, eventDate, loginLink, recaptchaKey, coverBlurhash, termsUrl, privacyUrl}) {
    const {t} = useTranslation();
    const {flash} = usePage().props;

    useEffect(() => {
        if (flash?.message) {
            toast.error(flash.message)
        }
    }, [flash?.message]);

    return (
        <Layout>
            <Head title={eventName} />
            <div className="relative full-screen">
                {coverBlurhash !== null &&
                    <div className="absolute object-cover object-center inset-0 w-full h-full -z-10">
                        <Blurhash
                            width={'100%'}
                            height={'100%'}
                            hash={coverBlurhash}
                        />
                    </div>}
                <img className="absolute object-cover object-center inset-0 w-full h-full -z-10" src={coverUrl}
                     alt="Cover image" />
                <div
                    className="inset-0 bg-linear-to-b absolute from-transparent via-[rgba(37,40,44,0)] via-40% to-gray-900/60">
                    <div className="absolute bottom-0 w-full text-center pb-8 text-[#FCFCFE]">
                        <h1 className="px-2 font-bold text-3xl pt-8">{eventName}</h1>
                        <p className="text-sm">{eventDate}</p>
                        <div className="mb-2 border-b border-2 mt-2 border-gray-100/15"></div>
                        <p className="mb-4">{t('Tap open below to join.')}</p>
                        <div className="flex items-center justify-center mx-4">
                            <InstallPWA loginLink={loginLink} recaptchaKey={recaptchaKey} termsUrl={termsUrl} privacyUrl={privacyUrl} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
